var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _rect3, _rect4, _path27, _path28, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTreeVisualizer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 354,
    height: 354,
    viewBox: "0 0 354 354",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.895508,
    y: 0.670898,
    width: 353.049,
    height: 353.049,
    rx: 4.74688,
    fill: "#1A350E"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.6153,
    y: 0.0281952,
    width: 118.775,
    height: 118.778,
    transform: "matrix(0.719102 -0.694905 0.694412 0.719578 92.0196 152.182)",
    stroke: "#7A922D",
    strokeWidth: 2.28551,
    strokeDasharray: "4.57 4.57"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M136.711 164.141C134.528 163.061 133.489 162.18 131.978 160.059C128.549 165.462 126.36 168.079 118.923 167.244C115.496 166.918 109.784 162.182 113.537 156.139C115.659 153.69 121.371 153.853 121.697 158.426C121.044 160.712 117.78 160.222 116.801 157.119C114.68 159.732 114.843 164.141 119.412 164.468C124.635 164.795 127.898 160.875 125.124 154.343L126.593 151.567H123.003C116.801 149.281 113.049 148.241 106.846 155.649C105.704 156.629 102.077 155.903 101.624 157.119C107.499 158.262 111.416 169.531 115.985 171.164C123.003 174.103 128.062 170.347 136.711 164.141Z",
    fill: "url(#paint0_linear_1_2384)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M131.162 140.952L133.121 142.585C130.68 145.092 129.041 146.341 128.062 151.73C125.287 148.627 112.884 143.891 112.884 133.44C116.486 134.36 121.371 132.133 127.082 131.807C127.151 135.629 127.73 137.683 131.162 140.952Z",
    fill: "url(#paint1_linear_1_2384)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M139.812 130.664C139.695 135.146 140.062 136.839 141.281 138.829C131.162 137.686 125.444 129.451 127.246 115.966C128.405 118.409 129.151 119.727 131.816 121.355C132.541 127.096 134.432 129.013 139.812 130.664Z",
    fill: "url(#paint2_linear_1_2384)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M139.309 119.232C130.836 122.172 127.922 118.142 126.919 107.311C135.118 107.466 141.28 110.903 139.309 119.232Z",
    fill: "url(#paint3_linear_1_2384)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M140.301 111.883L136.548 107.801C147.759 106.132 152.867 108.617 155.315 113.68C153.628 114.127 152.597 114.598 150.582 115.966C147.645 112.7 144.963 112.041 140.301 111.883Z",
    fill: "url(#paint4_linear_1_2384)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M164.618 160.875C166.739 183.575 163.802 199.252 148.135 199.252L176.367 226.198V134.583C174.055 138.941 171.982 141.141 166.576 144.545C158.337 141.818 153.848 140.186 149.277 134.583C147.319 131.643 147.319 122.008 156.621 121.682C163.475 120.375 167.065 131.643 159.395 132.133C154.499 132.787 154.826 125.111 161.027 128.051C159.232 118.905 146.339 127.071 154.499 135.073C161.829 138.647 168.762 136.725 167.881 125.928C166.249 118.905 160.701 118.089 156.295 114.496C153.52 116.782 149.353 117.772 147.319 121.355C145.703 121.114 145.106 120.851 144.055 120.375C133.937 142.422 162.985 149.117 164.618 160.875Z",
    fill: "url(#paint5_linear_1_2384)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M176.53 130.827C170.658 119.044 166.175 116.126 157.437 113.19C158.972 103.287 161.411 100.636 166.902 98.0022C168.507 90.6214 170.238 86.7223 176.53 80.6917V88.0405H176.367C175.784 88.7379 175.361 89.0649 174.409 89.5102C175.473 90.5733 175.919 91.1825 176.53 92.2864V103.065H176.367C176.301 102.984 176.236 102.906 176.173 102.829L176.172 102.828C175.129 101.565 174.487 100.788 173.756 98.4921C174.455 97.2224 174.579 96.4619 174.572 95.0626C173.56 93.8408 173.042 93.5691 172.124 93.103C171.374 95.7804 170.899 97.1894 169.839 99.3086C172.186 101.034 173.606 102.819 175.763 105.531C176.009 105.84 176.264 106.16 176.53 106.494V110.577C175.143 114.344 174.229 115.952 172.451 118.089C174.396 120.241 175.264 121.898 176.53 125.438V130.827ZM171.471 116.946C173.524 113.814 174.263 112.018 175.225 108.78L175.199 108.748C173.006 106.008 171.769 104.462 167.392 101.922C165.549 102.394 164.583 104.408 162.985 110.577C166.746 112.033 168.672 113.267 171.471 116.946Z",
    fill: "url(#paint6_linear_1_2384)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M163.312 170.02C163.312 161.855 154.826 156.793 150.42 162.345C155.208 163.939 158.048 165.595 163.312 170.02Z",
    fill: "url(#paint7_linear_1_2384)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M151.889 149.77C156.157 152.214 158.168 153.932 160.538 158.099C152.807 157.976 148.59 158.194 144.218 166.428C141.77 161.202 132.468 160.875 131.652 154.67C130.183 148.464 131.652 141.768 142.097 140.789C144.118 144.867 145.79 146.561 149.114 148.464C146.503 153.363 141.77 154.18 140.791 150.26C143.729 150.26 144.218 148.301 142.097 146.341C138.017 145.688 136.711 147.647 136.711 151.077C138.18 156.303 146.503 158.916 151.889 149.77Z",
    fill: "url(#paint8_linear_1_2384)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M216.024 164.631C218.207 163.551 219.246 162.67 220.756 160.549C224.186 165.952 226.375 168.569 233.812 167.734C237.239 167.408 242.951 162.672 239.197 156.629C237.076 154.18 231.364 154.343 231.038 158.916C231.69 161.202 234.954 160.712 235.933 157.609C238.055 160.222 237.892 164.631 233.322 164.958C228.1 165.285 224.836 161.365 227.61 154.833L226.142 152.057H229.732C235.933 149.77 239.685 148.73 245.888 156.139C247.031 157.119 250.658 156.393 251.111 157.609C245.236 158.752 241.319 170.02 236.749 171.654C229.732 174.593 224.673 170.837 216.024 164.631Z",
    fill: "url(#paint9_linear_1_2384)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M221.572 141.442L219.614 143.075C222.055 145.582 223.694 146.831 224.673 152.22C227.447 149.117 239.85 144.381 239.85 133.93C236.248 134.85 231.364 132.623 225.652 132.297C225.583 136.119 225.004 138.173 221.572 141.442Z",
    fill: "url(#paint10_linear_1_2384)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M212.922 131.153C213.04 135.635 212.673 137.329 211.454 139.319C221.572 138.176 227.29 129.941 225.488 116.456C224.329 118.899 223.584 120.217 220.919 121.845C220.194 127.586 218.302 129.503 212.922 131.153Z",
    fill: "url(#paint11_linear_1_2384)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M213.426 119.722C221.899 122.661 224.813 118.632 225.815 107.801C217.617 107.956 211.454 111.393 213.426 119.722Z",
    fill: "url(#paint12_linear_1_2384)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M212.433 112.373L216.187 108.29C204.975 106.622 199.867 109.107 197.419 114.17C199.106 114.617 200.138 115.088 202.152 116.456C205.09 113.19 207.771 112.531 212.433 112.373Z",
    fill: "url(#paint13_linear_1_2384)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M188.117 161.365C185.995 184.065 188.933 199.742 204.6 199.742L176.367 226.688V135.073C178.68 139.431 180.753 141.631 186.159 145.035C194.397 142.308 198.886 140.676 203.458 135.073C205.416 132.133 205.416 122.498 196.114 122.172C189.26 120.865 185.669 132.133 193.34 132.623C198.235 133.276 197.909 125.601 191.708 128.541C193.503 119.395 206.395 127.561 198.235 135.563C190.905 139.137 183.973 137.214 184.853 126.418C186.485 119.395 192.034 118.579 196.44 114.986C199.215 117.272 203.381 118.262 205.416 121.845C207.032 121.604 207.629 121.341 208.68 120.865C218.798 142.912 189.749 149.607 188.117 161.365Z",
    fill: "url(#paint14_linear_1_2384)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M176.204 131.317C182.076 119.534 186.56 116.616 195.298 113.68C193.762 103.776 191.324 101.126 185.833 98.4921C184.228 91.1114 182.497 87.2122 176.204 81.1816V88.5304H176.367C176.95 89.2279 177.374 89.5548 178.326 90.0001C177.262 91.0632 176.815 91.6724 176.204 92.7764V103.555H176.367C176.434 103.474 176.498 103.396 176.561 103.319L176.562 103.318C177.606 102.055 178.248 101.278 178.978 98.982C178.279 97.7123 178.156 96.9518 178.162 95.5526C179.175 94.3307 179.692 94.059 180.61 93.5929C181.361 96.2703 181.835 97.6793 182.895 99.7985C180.549 101.524 179.128 103.309 176.971 106.021C176.726 106.33 176.471 106.65 176.204 106.984V111.067C177.592 114.834 178.505 116.442 180.284 118.579C178.338 120.731 177.47 122.388 176.204 125.928V131.317ZM181.263 117.436C179.21 114.304 178.472 112.508 177.51 109.27L177.536 109.238C179.728 106.498 180.966 104.952 185.343 102.411C187.186 102.884 188.151 104.898 189.749 111.067C185.989 112.523 184.062 113.757 181.263 117.436Z",
    fill: "url(#paint15_linear_1_2384)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M189.422 170.51C189.422 162.345 197.909 157.283 202.315 162.835C197.526 164.429 194.687 166.085 189.422 170.51Z",
    fill: "url(#paint16_linear_1_2384)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M200.846 150.26C196.577 152.704 194.566 154.421 192.197 158.589C199.927 158.466 204.145 158.684 208.516 166.918C210.964 161.692 220.266 161.365 221.082 155.16C222.551 148.954 221.082 142.258 210.638 141.278C208.616 145.357 206.945 147.051 203.62 148.954C206.232 153.853 210.965 154.67 211.943 150.75C209.006 150.75 208.516 148.791 210.638 146.831C214.718 146.178 216.023 148.137 216.023 151.567C214.554 156.793 206.231 159.406 200.846 150.26Z",
    fill: "url(#paint17_linear_1_2384)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M67.8282 278.398H62.5866V299.635H54.8598V278.398H49.3019L49.7538 271.574H68.2801L67.8282 278.398ZM76.9177 287.48V299.635H69.4168V277.991H76.014L76.4658 279.301H76.6466C77.3394 278.518 78.0323 278.021 78.7252 277.81C79.4481 277.569 80.6079 277.449 82.2045 277.449L81.8882 284.678H79.8096C78.6348 284.678 77.8516 284.859 77.4599 285.221C77.0985 285.582 76.9177 286.335 76.9177 287.48ZM92.6188 283.91C91.8356 283.91 91.3235 284.181 91.0825 284.724C90.8415 285.236 90.721 286.034 90.721 287.118H94.6522V286.034C94.6522 284.618 93.9744 283.91 92.6188 283.91ZM92.7996 277.449C95.9024 277.449 98.1165 278.202 99.4419 279.708C100.798 281.184 101.475 283.308 101.475 286.079C101.475 286.441 101.37 288.067 101.159 290.959H90.8566C90.8566 293.219 91.8959 294.348 93.9744 294.348C94.9685 294.348 96.9115 294.002 99.8034 293.309L100.436 298.912C97.9056 299.695 95.3752 300.087 92.8448 300.087C89.742 300.087 87.3622 299.078 85.7054 297.059C84.0485 295.011 83.2201 292.24 83.2201 288.745C83.2201 281.214 86.4133 277.449 92.7996 277.449ZM112.608 283.91C111.825 283.91 111.313 284.181 111.072 284.724C110.831 285.236 110.711 286.034 110.711 287.118H114.642V286.034C114.642 284.618 113.964 283.91 112.608 283.91ZM112.789 277.449C115.892 277.449 118.106 278.202 119.432 279.708C120.787 281.184 121.465 283.308 121.465 286.079C121.465 286.441 121.359 288.067 121.149 290.959H110.846C110.846 293.219 111.885 294.348 113.964 294.348C114.958 294.348 116.901 294.002 119.793 293.309L120.426 298.912C117.895 299.695 115.365 300.087 112.834 300.087C109.732 300.087 107.352 299.078 105.695 297.059C104.038 295.011 103.21 292.24 103.21 288.745C103.21 281.214 106.403 277.449 112.789 277.449ZM153.969 271.574L149.225 299.635H137.296L132.235 271.574H140.775L143.215 289.965H143.983L145.836 271.574H153.969ZM165.189 284.407C165.189 282.208 165.852 280.506 167.177 279.301C168.533 278.066 170.386 277.449 172.735 277.449C175.085 277.449 177.465 277.75 179.875 278.352L179.107 284.633C176.034 283.94 173.97 283.594 172.916 283.594C172.283 283.594 171.967 283.85 171.967 284.362C171.967 284.693 172.314 284.995 173.006 285.266C175.416 286.139 177.224 287.134 178.429 288.248C179.664 289.363 180.281 291.035 180.281 293.264C180.281 295.493 179.709 297.195 178.564 298.37C177.42 299.515 175.657 300.087 173.278 300.087C170.928 300.087 168.578 299.786 166.229 299.183L166.726 293.083C169.738 293.896 171.681 294.303 172.555 294.303C173.458 294.303 173.91 294.092 173.91 293.67C173.91 293.249 173.579 292.917 172.916 292.676C170.235 291.652 168.277 290.568 167.042 289.423C165.807 288.248 165.189 286.576 165.189 284.407ZM187.186 300.087C183.601 300.087 181.809 298.099 181.809 294.122V277.991H189.49V292.27C189.49 293.023 189.822 293.399 190.484 293.399C191.328 293.399 192.036 293.188 192.608 292.767V277.991H200.199V299.545H193.015V297.963H192.834C191.177 299.379 189.294 300.087 187.186 300.087ZM202.901 294.665V270.671H210.357V292.27C210.357 292.782 210.462 293.143 210.673 293.354C210.914 293.565 211.321 293.67 211.893 293.67L211.306 300.087H208.821C206.833 300.087 205.341 299.68 204.347 298.867C203.383 298.023 202.901 296.623 202.901 294.665ZM229.76 283.639L229.534 292.993C229.534 293.565 229.67 293.957 229.941 294.167C230.242 294.348 230.739 294.439 231.432 294.439L230.754 299.906C229.007 300.027 228.043 300.087 227.862 300.087C225.633 300.087 224.217 299.319 223.615 297.782H223.389C222.274 299.319 220.557 300.087 218.237 300.087C216.46 300.087 215.089 299.515 214.125 298.37C213.192 297.225 212.725 295.659 212.725 293.67C212.725 291.17 213.493 289.438 215.029 288.474C216.596 287.51 219.051 286.877 222.395 286.576V285.492C222.395 284.648 221.973 284.227 221.129 284.227C219.683 284.227 217.424 284.663 214.351 285.537L213.222 278.94C217.078 277.946 220.286 277.449 222.846 277.449C225.407 277.449 227.199 277.946 228.224 278.94C229.248 279.934 229.76 281.5 229.76 283.639ZM221.039 294.8C222.154 294.8 222.711 294.213 222.711 293.038V290.824C221.596 290.974 220.798 291.215 220.316 291.547C219.864 291.848 219.638 292.375 219.638 293.128C219.638 294.243 220.105 294.8 221.039 294.8ZM233.128 294.665V270.671H240.584V292.27C240.584 292.782 240.69 293.143 240.9 293.354C241.141 293.565 241.548 293.67 242.12 293.67L241.533 300.087H239.048C237.06 300.087 235.568 299.68 234.574 298.867C233.61 298.023 233.128 296.623 233.128 294.665ZM270.037 299.635H253.816L253.635 295.297L260.322 284.317H253.364V277.991H269.585L269.857 282.012L263.395 293.399H270.037V299.635ZM280.953 283.91C280.17 283.91 279.658 284.181 279.417 284.724C279.176 285.236 279.056 286.034 279.056 287.118H282.987V286.034C282.987 284.618 282.309 283.91 280.953 283.91ZM281.134 277.449C284.237 277.449 286.451 278.202 287.776 279.708C289.132 281.184 289.81 283.308 289.81 286.079C289.81 286.441 289.704 288.067 289.494 290.959H279.191C279.191 293.219 280.23 294.348 282.309 294.348C283.303 294.348 285.246 294.002 288.138 293.309L288.771 298.912C286.24 299.695 283.71 300.087 281.179 300.087C278.076 300.087 275.697 299.078 274.04 297.059C272.383 295.011 271.555 292.24 271.555 288.745C271.555 281.214 274.748 277.449 281.134 277.449ZM299.407 287.48V299.635H291.906V277.991H298.503L298.955 279.301H299.135C299.828 278.518 300.521 278.021 301.214 277.81C301.937 277.569 303.097 277.449 304.693 277.449L304.377 284.678H302.299C301.124 284.678 300.34 284.859 299.949 285.221C299.587 285.582 299.407 286.335 299.407 287.48Z",
    fill: "#C6D17A"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M163.498 299.635H156.043V278.217H163.498V299.635ZM156.63 276.5C155.997 275.957 155.681 275.084 155.681 273.879C155.681 272.674 155.997 271.785 156.63 271.213C157.263 270.641 158.302 270.354 159.748 270.354C161.194 270.354 162.233 270.641 162.866 271.213C163.498 271.785 163.815 272.674 163.815 273.879C163.815 275.054 163.498 275.927 162.866 276.5C162.233 277.042 161.194 277.313 159.748 277.313C158.302 277.313 157.263 277.042 156.63 276.5ZM251.311 299.635H243.855V278.217H251.311V299.635ZM244.443 276.5C243.81 275.957 243.494 275.084 243.494 273.879C243.494 272.674 243.81 271.785 244.443 271.213C245.076 270.641 246.115 270.354 247.561 270.354C249.007 270.354 250.046 270.641 250.679 271.213C251.311 271.785 251.628 272.674 251.628 273.879C251.628 275.054 251.311 275.927 250.679 276.5C250.046 277.042 249.007 277.313 247.561 277.313C246.115 277.313 245.076 277.042 244.443 276.5Z",
    fill: "#1A350E"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M269.351 113.026C269.351 113.026 270.268 121.269 273.715 124.708C277.188 128.173 285.507 129.03 285.507 129.03C285.507 129.03 277.297 130 273.715 133.353C268.828 137.926 269.351 154.996 269.351 154.996C269.351 154.996 269.875 137.926 264.987 133.353C261.405 130 253.195 129.03 253.195 129.03C253.195 129.03 261.514 128.173 264.987 124.708C268.434 121.269 269.351 113.026 269.351 113.026Z",
    fill: "url(#paint18_linear_1_2384)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M235.08 205.784C235.08 205.784 235.997 214.027 239.444 217.466C242.917 220.931 251.236 221.788 251.236 221.788C251.236 221.788 243.026 222.759 239.444 226.111C234.557 230.685 235.08 247.754 235.08 247.754C235.08 247.754 235.604 230.685 230.716 226.111C227.134 222.759 218.924 221.788 218.924 221.788C218.924 221.788 227.243 220.931 230.716 217.466C234.163 214.027 235.08 205.784 235.08 205.784Z",
    fill: "url(#paint19_linear_1_2384)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M101.587 193.046C101.587 193.046 102.133 197.986 104.188 200.046C106.258 202.123 111.215 202.636 111.215 202.636C111.215 202.636 106.322 203.218 104.188 205.227C101.275 207.967 101.587 218.196 101.587 218.196C101.587 218.196 101.899 207.967 98.9864 205.227C96.8516 203.218 91.9585 202.636 91.9585 202.636C91.9585 202.636 96.9165 202.123 98.9864 200.046C101.041 197.986 101.587 193.046 101.587 193.046Z",
    fill: "url(#paint20_linear_1_2384)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M155.441 41.8245C155.441 41.8245 155.987 46.7639 158.042 48.8243C160.112 50.9006 165.069 51.4144 165.069 51.4144C165.069 51.4144 160.176 51.9958 158.042 54.0046C155.129 56.7453 155.441 66.9737 155.441 66.9737C155.441 66.9737 155.753 56.7453 152.84 54.0046C150.706 51.9958 145.812 51.4144 145.812 51.4144C145.812 51.4144 150.77 50.9006 152.84 48.8243C154.895 46.7639 155.441 41.8245 155.441 41.8245Z",
    fill: "url(#paint21_linear_1_2384)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M108.114 87.877C108.114 87.877 108.383 89.609 109.393 90.3314C110.41 91.0595 112.847 91.2397 112.847 91.2397C112.847 91.2397 110.442 91.4435 109.393 92.1479C107.961 93.1089 108.114 96.6955 108.114 96.6955C108.114 96.6955 108.268 93.1089 106.836 92.1479C105.787 91.4435 103.382 91.2397 103.382 91.2397C103.382 91.2397 105.819 91.0595 106.836 90.3314C107.846 89.609 108.114 87.877 108.114 87.877Z",
    fill: "url(#paint22_linear_1_2384)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M235.08 88.2034C235.08 88.2034 235.442 91.4749 236.799 92.8396C238.168 94.2149 241.445 94.5552 241.445 94.5552C241.445 94.5552 238.211 94.9402 236.799 96.2707C234.874 98.086 235.08 104.861 235.08 104.861C235.08 104.861 235.287 98.086 233.361 96.2707C231.95 94.9402 228.716 94.5552 228.716 94.5552C228.716 94.5552 231.993 94.2149 233.361 92.8396C234.719 91.4749 235.08 88.2034 235.08 88.2034Z",
    fill: "url(#paint23_linear_1_2384)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 243.73,
    y: 277.639,
    width: 7.50697,
    height: 21.5565,
    fill: "#C6D17A"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 156.257,
    y: 277.639,
    width: 7.50697,
    height: 21.5565,
    fill: "#C6D17A"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M247.647 265.881C247.647 265.881 248.097 268.408 249.145 269.457C250.348 270.662 253.195 270.781 253.195 270.781C253.195 270.781 250.348 270.899 249.145 272.104C248.097 273.153 247.647 275.68 247.647 275.68C247.647 275.68 247.196 273.153 246.148 272.104C244.945 270.899 242.098 270.781 242.098 270.781C242.098 270.781 244.945 270.662 246.148 269.457C247.196 268.408 247.647 265.881 247.647 265.881Z",
    fill: "#C6D17A"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M160.174 265.881C160.174 265.881 160.624 268.408 161.672 269.457C162.875 270.662 165.722 270.781 165.722 270.781C165.722 270.781 162.875 270.899 161.672 272.104C160.624 273.153 160.174 275.68 160.174 275.68C160.174 275.68 159.723 273.153 158.675 272.104C157.472 270.899 154.625 270.781 154.625 270.781C154.625 270.781 157.472 270.662 158.675 269.457C159.723 268.408 160.174 265.881 160.174 265.881Z",
    fill: "#C6D17A"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_2384",
    x1: 205.493,
    y1: 141.278,
    x2: 205.493,
    y2: 170.51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4D07C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388,
    stopColor: "#79922D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_2384",
    x1: 205.493,
    y1: 141.278,
    x2: 205.493,
    y2: 170.51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4D07C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388,
    stopColor: "#79922D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_2384",
    x1: 205.493,
    y1: 141.278,
    x2: 205.493,
    y2: 170.51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4D07C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388,
    stopColor: "#79922D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1_2384",
    x1: 205.493,
    y1: 141.278,
    x2: 205.493,
    y2: 170.51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4D07C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388,
    stopColor: "#79922D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1_2384",
    x1: 205.493,
    y1: 141.278,
    x2: 205.493,
    y2: 170.51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4D07C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388,
    stopColor: "#79922D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1_2384",
    x1: 205.493,
    y1: 141.278,
    x2: 205.493,
    y2: 170.51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4D07C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388,
    stopColor: "#79922D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1_2384",
    x1: 205.493,
    y1: 141.278,
    x2: 205.493,
    y2: 170.51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4D07C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388,
    stopColor: "#79922D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1_2384",
    x1: 205.493,
    y1: 141.278,
    x2: 205.493,
    y2: 170.51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4D07C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388,
    stopColor: "#79922D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1_2384",
    x1: 205.493,
    y1: 141.278,
    x2: 205.493,
    y2: 170.51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4D07C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388,
    stopColor: "#79922D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1_2384",
    x1: 205.493,
    y1: 141.278,
    x2: 205.493,
    y2: 170.51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4D07C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388,
    stopColor: "#79922D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1_2384",
    x1: 205.493,
    y1: 141.278,
    x2: 205.493,
    y2: 170.51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4D07C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388,
    stopColor: "#79922D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1_2384",
    x1: 205.493,
    y1: 141.278,
    x2: 205.493,
    y2: 170.51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4D07C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388,
    stopColor: "#79922D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1_2384",
    x1: 205.493,
    y1: 141.278,
    x2: 205.493,
    y2: 170.51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4D07C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388,
    stopColor: "#79922D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1_2384",
    x1: 205.493,
    y1: 141.278,
    x2: 205.493,
    y2: 170.51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4D07C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388,
    stopColor: "#79922D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1_2384",
    x1: 205.493,
    y1: 141.278,
    x2: 205.493,
    y2: 170.51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4D07C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388,
    stopColor: "#79922D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1_2384",
    x1: 205.493,
    y1: 141.278,
    x2: 205.493,
    y2: 170.51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4D07C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388,
    stopColor: "#79922D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1_2384",
    x1: 205.493,
    y1: 141.278,
    x2: 205.493,
    y2: 170.51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4D07C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388,
    stopColor: "#79922D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1_2384",
    x1: 205.493,
    y1: 141.278,
    x2: 205.493,
    y2: 170.51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4D07C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388,
    stopColor: "#79922D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_1_2384",
    x1: 269.351,
    y1: 113.026,
    x2: 269.351,
    y2: 154.996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A922D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_1_2384",
    x1: 235.08,
    y1: 205.784,
    x2: 235.08,
    y2: 247.754,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A922D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_1_2384",
    x1: 101.587,
    y1: 193.046,
    x2: 101.587,
    y2: 218.196,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A922D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_1_2384",
    x1: 155.441,
    y1: 41.8245,
    x2: 155.441,
    y2: 66.9737,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A922D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_1_2384",
    x1: 108.114,
    y1: 87.877,
    x2: 108.114,
    y2: 96.6955,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A922D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_1_2384",
    x1: 235.08,
    y1: 88.2034,
    x2: 235.08,
    y2: 104.861,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A922D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTreeVisualizer);
export default __webpack_public_path__ + "static/media/TreeVisualizer.307cb5b27bd0854a11ea7a000362f29d.svg";
export { ForwardRef as ReactComponent };